export { AlertPageComponent } from './alert-page.component';
